import { Reducer } from 'redux';
import { FinanceActionTypes, FinancialState } from './types';
import { StudentActionTypes } from '../types';

const initialState: FinancialState = {
  organisationSponsorship: {},
  scholarshipSponsorship: {},
  educationSponsorship: {},
  familySponsorship: {},
  otherSponsorship: {},
  courseFeeDepositReqd: '',
  courseFeeDeposit: 0,
  courseFeeDepositDate: '',
  courseFeeDepositNotReqdReason: '',
  accomDepositReqd: '',
  accomDeposit: 0,
  accomDepositDate: '',
  fundingSummary: {
    courseFees: [],
    studentLivingCost: {
      label: '',
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    spouseLivingCost: {
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    childrenLivingCost: {
      number: 0,
      amount: 0,
      remainingAmount: 0,
      funding: []
    },
    totalToBeShown: 0,
    totalRemaining: 0,
    totalInvalid: 0
  },
  isSectionStarted: false,
  isSectionComplete: false
};

const reducer: Reducer<FinancialState> = (state = initialState, action): FinancialState => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS:
      return {
        ...state,
        ...action.payload.student.finance
      };
    case StudentActionTypes.SAVE_PERSONAL_INFO_SUCCESS:
    case StudentActionTypes.SAVE_HISTORY_SUCCESS:
    case StudentActionTypes.SAVE_CONSENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_SUCCESS:
    case StudentActionTypes.SAVE_PRE_CAS_INTERVIEW_SUCCESS:
    case StudentActionTypes.SAVE_VISA_PREP_FORM_SUCCESS:
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
      return {
        ...state,
        ...action.payload.finance
      };
    case FinanceActionTypes.UPDATE_FINANCE_FIELD: {
      switch (action.payload.fieldName) {
        default:
          return {
            ...state,
            [action.payload.fieldName]: action.payload.value
          };
      }
    }
    default:
      return state;
  }
};

export { reducer as financialsReducer };
